import loadConsumerMailboxOptions from './loadConsumerMailboxOptions';
import { FromViewState, LoadAliasActionStatus } from 'owa-mail-compose-store';
import getAllFromAddresses from '../utils/fromAddressUtils/getAllFromAddresses';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import { action } from 'satcheljs/lib/legacy';

export default action('toggleFromContextMenu')(async function toggleFromContextMenu(
    viewState: FromViewState
) {
    viewState.isFromContextMenuShown = !viewState.isFromContextMenuShown;

    if (viewState.isFromContextMenuShown) {
        if (isConsumer() && viewState.loadAliasActionStatus == LoadAliasActionStatus.NotStarted) {
            viewState.loadAliasActionStatus = LoadAliasActionStatus.Started;
            await loadConsumerMailboxOptions();
            viewState.loadAliasActionStatus = LoadAliasActionStatus.Finished;
        }

        // Since these addresses will be shown to the user in the From dropdown,
        // don't include user proxy addresses for enterprise users as this field
        // contains information that should not be exposed to the user
        viewState.sendAsEmailAddresses = getAllFromAddresses(
            false /* includeProxyAddressesForEnt */
        );
    }
});
